/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServizioMensaTemplate } from './servizio-mensa-template';


export interface ServizioDaTemplateForm { 
    template: ServizioMensaTemplate;
    data_inizio: string;
    data_fine?: string;
}



